import TypeFormController from './type.form.controller';

export default {
    template: require('./type.form.html'),
    controller: TypeFormController
};
